






























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { CourseItem, checkAuth } from '@/apis/courseList/courseList';

@Component({})
export default class CourseDemo extends Vue {
  @Prop() itemData!: CourseItem;
  @Prop() disableMoreActions!: boolean;
  @Prop({default:''}) showType!: string; //'isTop' 置顶类型 //sort 排序

  get isShowMoreActions(): boolean {
    return !this.disableMoreActions;
  }

  handleCode() {
    if (this.itemData.role === 1) {
      this.$emit('itemCodeActions', this.itemData);
    }
  }
  
  handleMore() {
    this.$emit('itemMoreActions', this.itemData);
  }

  //跳转过去
  handleDetails(itemData: any) {
    this.$router.push(`/courseHome?courseId=${itemData.courseid}&courseRole=0`);
  }

  created(){

  }

  // 上报资料校验数据
  @Emit('check-info')
  checkInfoEmit(roleobj: any, courseId: string) {
    return {
      roleobj,
      courseId
    };
  }
}
